import styled from 'styled-components'

/** Row options trigger: 26×26 icon button, the record table convention. */
export const OptionsTrigger = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 4px;
  background: #f0f0f0;
  color: #757575;
  font-size: 14px;
  cursor: pointer;
  transition: border-color 200ms ease;

  &:hover,
  &:focus-visible,
  &[aria-expanded='true'] {
    outline: none;
    border-color: #0669f5;
  }

  &:disabled {
    opacity: 0.48;
    cursor: not-allowed;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`
